
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Signup from './components/Signup';
import Login from './components/Login';
import BrandProfileFormFull from './components/BrandProfileFormFull';
import Home from './components/Home';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from "./components/FilesDashboard";
import Account from "./components/Accountpage";
import ContentHistory from "./components/ContentHistory";
import LandingPage from "./components/Landingpage";
import CheckoutPage from "./components/Checkoutpage";
import CheckoutSuccess  from "./components/Checkoutsuccess";
import CheckoutCancel   from "./components/Checkoutcancel";
import PrivacyPolicy   from "./components/Privacypolicy";
import TermsOfService   from "./components/Termsofservice";
import CookiePolicy   from "./components/Cookiepolicy";
import ResetPassword from "./components/Resetpassword";
import AutoPostDashboard from "./components/AutoPostDashboard";
import AdminLogin from "./components/AdminLogin";
import AdminPanel from "./components/AdminPanel";
import AdminRoute from "./components/AdminRoute";
import CampaignMode from "./components/CampaignMode";
import EbookWizard from "./components/EbookWizard";
import EmailSequenceWizard from "./components/EmailSequenceWizard";
import VideoWizard from "./components/VideoWizard";
import MyVideos from "./components/MyVideos";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
         <Route path="/terms" element={<TermsOfService />} />
         <Route path="/cookies" element={<CookiePolicy />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/brand-profile" element={<BrandProfileFormFull />} />
          <Route path="/checkout"          element={<CheckoutPage />} />
        <Route path="/checkout/success"  element={<CheckoutSuccess />} />
        <Route path="/checkout/cancel"   element={<CheckoutCancel />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        {/* Protected Home */}
        <Route 
          path="/home" 
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          } 
        />
          <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } 
        />
           <Route 
          path="/account" 
          element={
            <ProtectedRoute>
              <Account />
            </ProtectedRoute>
          } 
        />

           <Route
          path="/history"
          element={
            <ProtectedRoute>
              <ContentHistory />
            </ProtectedRoute>
          }
        />

           <Route
          path="/autopost"
          element={
            <ProtectedRoute>
              <AutoPostDashboard />
            </ProtectedRoute>
          }
        />

           <Route
          path="/campaign"
          element={
            <ProtectedRoute>
              <CampaignMode />
            </ProtectedRoute>
          }
        />

           <Route
          path="/ebook"
          element={
            <ProtectedRoute>
              <EbookWizard />
            </ProtectedRoute>
          }
        />

           <Route
          path="/email-sequences"
          element={
            <ProtectedRoute>
              <EmailSequenceWizard />
            </ProtectedRoute>
          }
        />

           <Route
          path="/video"
          element={
            <ProtectedRoute>
              <VideoWizard />
            </ProtectedRoute>
          }
        />

           <Route
          path="/my-videos"
          element={
            <ProtectedRoute>
              <MyVideos />
            </ProtectedRoute>
          }
        />

        {/* Admin routes — separate auth (admin_token, not auth_token) */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <AdminPanel />
            </AdminRoute>
          }
        />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/signup" replace />} />
      </Routes>
    </Router>
  );
}
